import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '@bari/core';
import { Transaction } from '@bari/shared/model/transaction.model';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../authentication/authentication.service";
var TransactionWalletService = (function () {
    function TransactionWalletService(http, userService) {
        this.http = http;
        this.userService = userService;
        this._user = userService.credentials;
    }
    TransactionWalletService.prototype.getWalletTransactions = function (accountId, page) {
        var url = "{api}/account/v1/transactions?accountId=" + accountId;
        url += "&itemsPerPage=6";
        if (page) {
            url += "&page=" + page;
        }
        return this.http.get(url).pipe(map(function (data) {
            data.items = data.items.map(function (transaction) { return new Transaction().deserialize(transaction.item); });
            return {
                next: data.hasNextPage,
                transactions: data.items
            };
        }));
    };
    TransactionWalletService.ngInjectableDef = i0.defineInjectable({ factory: function TransactionWalletService_Factory() { return new TransactionWalletService(i0.inject(i1.HttpClient), i0.inject(i2.AuthenticationService)); }, token: TransactionWalletService, providedIn: "root" });
    return TransactionWalletService;
}());
export { TransactionWalletService };
